import moment from 'moment-timezone';

export class ServerClock {
    constructor(serverTime = null) {
        this.sync(serverTime);
    }

    sync(serverTime) {
        if (!serverTime) {
            this.serverTimestamp = null;
            this.performanceStart = null;
            return;
        }
        const timestamp = moment(serverTime, 'YYYY-MM-DD HH:mm:ss').valueOf();
        this.serverTimestamp = Number.isFinite(timestamp) ? timestamp : null;
        this.performanceStart = performance.now();
    }

    isReady() {
        return this.serverTimestamp != null;
    }

    nowTimestamp() {
        if (!this.isReady()) return null;
        return this.serverTimestamp + (performance.now() - this.performanceStart);
    }

    nowMoment() {
        const timestamp = this.nowTimestamp();
        return timestamp == null ? null : moment(timestamp);
    }

    secondsUntil(date) {
        const timestamp = this.nowTimestamp();
        if (timestamp == null) return null;
        return Math.floor((moment(date, 'YYYY-MM-DD HH:mm:ss').valueOf() - timestamp) / 1000);
    }
}

export const formatDuration = (seconds) => {
    const safeSeconds = Math.max(0, Math.floor(seconds || 0));
    const hours = String(Math.floor(safeSeconds / 3600)).padStart(2, '0');
    const minutes = String(Math.floor((safeSeconds % 3600) / 60)).padStart(2, '0');
    const remainingSeconds = String(safeSeconds % 60).padStart(2, '0');
    return `${hours}:${minutes}:${remainingSeconds}`;
};
